// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__aE+IE","label":"Radio_label__kOInv","options":"Radio_options__eLjO2"};